import { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import { FiPlus } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import Swal from "sweetalert2";

const AddEditEnvelope = () => {
  const history = useNavigate();
  const { id } = useParams();
  const [submitted, setSubmitted] = useState(false);
  const [form, setform] = useState({ name: "", front_image: "", back_image: "" })
  const formValidation = [
    { key: "name", required: true, message: "Envelope name is required" },
    { key: "front_image", required: true, message: "Front image is required" },
    // { key: "back_image", required: true, message: "Back image is required" },
  ]

  useEffect(() => {
    if (id) {
      getEnvelopeDetail()
    }
  }, [])

  const getEnvelopeDetail = () => {
    loader(true)
    ApiClient.get(`envelope/detail?id=${id}`).then((res) => {
      if (res.success) {
        setform({ 
          name: res?.data?.name,
          front_image: res?.data?.front_image,
          // back_image: res?.data?.back_image
        })
      }
      loader(false)
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    let invalid = methodModel.getFormError(formValidation, form)
    if (invalid) return
    let method = "post"
    let url = "envelope/add"
    let value = {
      ...form,
    }
    if (id) {
      method = "put"
      url = "envelope/update"
      value = {
        ...form,
        id: id,
      }
    } else {
      delete value.id
    }
    loader(true)
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history(`/envelope`)
      }
      loader(false)
    })
  }

  const ImageUpload = (e, key) => {
    let files = e.target.files
    let file = files.item(0)
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"]; // Add more image types if needed
    if (!allowedTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Only JPG and PNG images are allowed.",
      });
      return;
    }
    loader(true)
    ApiClient.postFormData('upload/image', { file: file }).then(res => {
      if (res.success) {
        setform({ ...form, [key]: res?.fileName })
      }
      loader(false)
    })
  }

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit} autoComplete="one-time-code">
          <div className="pprofile1">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link to={`/envelope`} className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3">
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">{id ? "Edit" : "Add"} Front Image</h3>
              </div>
            </div>
            <h3 className="ViewUser mb-3"></h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="flex flex-col">
                <div className="mb-3">
                  <FormControl
                    type="text"
                    name="name"
                    label="Name"
                    placeholder="Name"
                    value={form.name}
                    onChange={(e) => setform({ ...form, name: e })}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="lablefontcls">Front Image (JPG/PNG) (Dimension: 740 px width x 880 px height)<span className="text-red-600">*</span></label>
                  {form?.front_image ?
                    <div>
                      <span className="relative inline-block">
                        <img src={methodModel.userImg(form?.front_image)} className="rounded-full h-20 w-20 block" alt="Front Image" />
                        <IoCloseOutline className="absolute top-2 -right-5 pointer hover:text-red-600" onClick={e => setform({ ...form, front_image: "" })} size={25} />
                      </span>
                    </div>
                    :
                    <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                      <FiPlus />
                      <input
                        id="dropzone-file"
                        type="file"
                        className="hidden"
                        accept=".jpg, .jpeg, .png"
                        value={""}
                        onChange={(e) => ImageUpload(e, 'front_image')}
                      />
                      Upload Image
                    </label>
                  }
                  {submitted && !form?.front_image && <div className="text-red-600">Front image is required</div>}
                </div>
                {/* <div className="mb-3">
                  <label className="lablefontcls">Back Image (JPG/PNG) <span className="text-red-600">*</span></label>
                  {form?.back_image ?
                    <div>
                      <span className="relative inline-block">
                        <img src={methodModel.userImg(form?.back_image)} className="rounded-full h-20 w-20 block" alt="Back Image" />
                        <IoCloseOutline className="absolute top-2 -right-5 pointer hover:text-red-600" onClick={e => setform({ ...form, back_image: "" })} size={25} />
                      </span>
                    </div>
                    :
                    <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                      <FiPlus />
                      <input
                        id="dropzone-file"
                        type="file"
                        className="hidden"
                        accept=".jpg, .jpeg, .png"
                        value={""}
                        onChange={(e) => ImageUpload(e, 'back_image')}
                      />
                      Upload Image
                    </label>
                  }
                  {submitted && !form?.back_image && <div className="text-red-600">Back image is required</div>}
                </div> */}
              </div>
            </div>
            <div className="text-right">
              <button type="submit" className="text-white bg-[#F58D18] bg-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                {id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditEnvelope;